import { diContainer, serviceNames } from '../diContainer/diContainer';
import Transaction from '../domain/entities/Transaction/Transaction';
import ShippingUIState from '../stores/UIState/ShippingUIState';
import TransactionRepository from '../repositories/TransactionRepository';
import { DeliveryOptions } from '../constants/Constants';
import { LogServiceError } from '../application/services/LogServiceError';
import { toJS } from 'mobx';

export default class CheckTransactionBreakingMissingData {
  private shippingUIState: ShippingUIState;

  private transactionRepository: TransactionRepository;

  constructor() {
    this.shippingUIState = diContainer.get(serviceNames.shippingUIState);
    this.transactionRepository = diContainer.get(serviceNames.transactionRepository);
  }

  public async execute(): Promise<void> {
    this.restorDefaults();
    await this.checkDataLoaded();
  }

  private restorDefaults(): void {
    this.shippingUIState.restoreDefaults();
  }

  private async checkDataLoaded(): Promise<void> {
    const transaction = await this.transactionRepository.getTransaction();
    this.checkShippingMethods(transaction);
  }

  private checkShippingMethods(transaction: Transaction): void {
    const isHomeShippingMethodMissing = !transaction.deliveryOptions
      ?.find(delivery => delivery.name === DeliveryOptions.HOME_DELIVERY)?.shipMethods?.length;
    const isElectronicShippingMethodMissing = !transaction.deliveryOptions
      ?.find(delivery => delivery.name === DeliveryOptions.ELECTRONIC_DELIVERY)?.shipMethods?.length;

    const isFailed = transaction.isTransactionLoaded && (isHomeShippingMethodMissing && isElectronicShippingMethodMissing);
    this.shippingUIState.updateisShippingMethodsMissing(isFailed);

    if (isFailed) {
      const hasCartItems = transaction.cart?.cartItems?.length > 0;
      // We only want to log this fatal error if there are cart items, otherwise it is expected that there are no shipping methods
      if (hasCartItems) {
        LogServiceError.instance.captureMessage(
          'RC Missing shipping methods for home delivery',
          {
            'rc-missing-shipping-methods': true,
          },
          {
            cartItems: toJS(transaction.cart?.cartItems || []),
            deliveryMethods: toJS(transaction?.deliveryOptions || []),
            rcoTransactionId: transaction?.transId,
          },
          'fatal');
      } else {
        // No cart items, so it's expected that there are no shipping methods
        LogServiceError.instance.captureMessage(
          'RC Missing cart items and shipping methods for home delivery',
          {
            'rc-missing-cart-items-and-shipping-methods': true,
          },
          {
            cartItems: toJS(transaction.cart?.cartItems || []),
            deliveryMethods: toJS(transaction?.deliveryOptions || []),
            rcoTransactionId: transaction?.transId,
          },
          'warning');
      }
    }
  }
}
